import api from "../../../api";
//escalation

export function escalations() {
  return api.get("/escalatedCases");
}
//salesV2

export function salesDashboard(sd, ed) {
  return api.get(`sales-analytics?startDate=${sd}&endDate=${ed}`);
}
//post sales v2 api

export function callAnalytics(sd, ed) {
  return api.get(`call-analytics?startDate=${sd}&endDate=${ed}`);
}

export function engagementReport(sd, ed) {
  return api.get(`engagement-report?startDate=${sd}&endDate=${ed}`);
}

export function escalationAnalytics(sd, ed) {
  return api.get(`escalation-analytics?startDate=${sd}&endDate=${ed}`);
}

export function repAssignment() {
  return api.get("reps-assignment-summary");
}

export function attemptByEngagements(payload) {
  return api.post("engagements-unanswered-count", {
    engagements: payload,
  });
}